import React, { useState } from "react";
import { DashboardMeetingsList } from "../components/dashboard/DashboardMeetingsList";
import { DashboardActionItemsList } from "../components/dashboard/DashboardActionItemsList";
import { DefaultView } from "../components/capture";
import { HelloBlock } from "../components/dashboard/HelloBlock";
import { QuoteBlock } from "../components/dashboard/QuoteBlock";
import { DashboardStats } from "../components/dashboard/DashboardStats";

export default function Index() {
  const [activeSection, setActiveSection] = useState("default");

  return (
    <div className="w-full bg-slate-100 dark:bg-slate-900 min-h-screen">
      <div className="container mx-auto px-4">
        {/* Hello Block - Full Width */}
        <div className="mb-4">
          <HelloBlock />
        </div>

        {/* Stats Section - rendered in a 3-column grid */}
        <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {/* First Stat Block */}
          <DashboardStats />
          {/* Second Stat Block (added to the second column) */}
          <DashboardStats />
          <DashboardStats />
        </div>

        {/* Custom Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          {/* Capture Interface */}
          <div className="md:col-span-2 md:row-span-1">
            <DefaultView setActiveSection={setActiveSection} />
          </div>

          {/* Action Items */}
          <div className="md:col-span-3 md:row-span-2">
            <DashboardActionItemsList />
          </div>

          {/* Meetings */}
          <div className="md:col-span-2 md:row-span-3">
            <DashboardMeetingsList />
          </div>

          {/* Quote Block */}
          <div className="md:col-span-3 md:row-span-1">
            <QuoteBlock />
          </div>
        </div>
      </div>
    </div>
  );
}